import './index.scss';
import 'lib/anyfont/index.scss';
import 'lib/semantic-ui/dist/semantic.css';
import { initSentry } from '@anyroad/sentry';
import { wrapAllComponents } from 'lib/withIntl';

require('lib/semantic-ui/dist/semantic.js');
require('action_creators');
require('stores/anyguide_bookings');
require('stores/shared');

const _ = require('underscore');
_.mixin(require('lib/underscore_extensions'));
_.str = require('underscore.string/index.js');

const React = require('react');

window.React = React;
window.ReactDOM = require('react-dom');

initSentry({ application: 'bookings' });

const Bookings = require('views/anyguide_bookings').default;
const Feedback = require('views/feedback').default;

window.Views = wrapAllComponents({
  Anyguide: {
    Bookings,
    Feedback,
  },
});

require('initializers/flux_stores');
